import { Link } from 'react-router-dom';
import { categories } from '@/mocks/articles';

function CategoryCard({ cat, index }: { cat: typeof categories[0]; index: number }) {
  return (
    <Link
      to="/"
      className="group bg-background-50 rounded-2xl p-5 md:p-6 transition-all duration-300 hover:-translate-y-1 cursor-pointer block"
      style={{ animationDelay: `${index * 80}ms` }}
    >
      <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-xl bg-secondary-100 text-foreground-700 mb-4 group-hover:bg-primary-100 group-hover:text-primary-500 transition-colors">
        <i className={`${cat.icon} text-xl md:text-2xl`}></i>
      </div>
      <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2 whitespace-nowrap">
        {cat.name}
      </h3>
      <p className="text-foreground-500 text-xs md:text-sm leading-relaxed line-clamp-2">
        {cat.description}
      </p>
    </Link>
  );
}

export default function CategoryGrid() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-10 md:mb-14">
          <p className="text-xs md:text-sm font-medium text-foreground-400 uppercase tracking-wider mb-3">
            热门分类
          </p>
          <h2 className="font-heading text-3xl md:text-5xl font-black text-foreground-950 leading-tight">
            吃瓜不迷路
            <br />
            分类找大瓜
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat, idx) => (
            <CategoryCard key={cat.slug} cat={cat} index={idx} />
          ))}
        </div>
      </div>
    </section>
  );
}